export default "__VITE_ASSET__gyYg2My6__"